<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> User List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Join_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> Login_at
                <b-button size="sm" variant="info" @click="set_sd('', 'last_visit')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'last_visit')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'last_visit')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'last_visit')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'last_visit')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'last_visit')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.last_visit_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.last_visit_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_verified">Verified</label>
              <br>
              <select v-model="so.opt['is_verified']" @change="refresh">
                <option disabled value="">Please select Success or Failed</option>
                <option value="true">Verified</option>
                <option value="false">Not Verified</option>
              </select>
            </b-form-group>
          </b-col>
          <!-- <b-col md="4">
            <b-form-group>
              <label for="opt_permission">Permission</label>
              <br>
              <select v-model="so.opt['permissions']" @change="refresh">
                  <option disabled value="">Please select Success or Failed</option>
                  <option value="true">Success</option>
                  <option value="false">Failed</option>
                </select>
            </b-form-group>
          </b-col> -->
          <b-col md="4">
            <b-form-group>
              <label for="opt_allow">Allow Login</label>
              <br>
              <select v-model="so.opt['is_alive']" @change="refresh">
                  <option disabled value="">Please select Success or Failed</option>
                  <option value="true">Allow</option>
                  <option value="false">Not Allow</option>
                </select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_username">username</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_username" v-model="so.opt['username']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_addr">Last Address</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_addr" v-model="so.opt['last_addr']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_nickname">Nickname</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_nickname" v-model="so.opt['nickname']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2">
          <b-badge variant="primary">
            TOTAL : {{(summaryData.enable + summaryData.disable)  || 0}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{summaryData.enable || 0}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{summaryData.disable || 0}}
          </b-badge>
        </b-col>
        <b-col sm="10" class="md-12">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <!-- <b-dropdown-item size="sm" @click="so.sk='permissions';so.skt='Permission'; so.sv = 'Owner'">Permission</b-dropdown-item> -->
                <b-dropdown-item size="sm" @click="so.sk='is_alive';so.skt='Allow Login'; so.sv = ''">Allow Login</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='username';so.skt='username'; so.sv = ''">Username</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='nickname';so.skt='Nickname'; so.sv = ''">Nickname</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='last_addr';so.skt='Last Address'; so.sv = ''">Last Address</b-dropdown-item>
              </b-dropdown>
              <v-select :disabled="so.adv" v-if="so.sk == 'permissions'" v-model="so.sv" :options="codes.permissions_user"></v-select>

              <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_alive'" @change="$refs._list.refresh()">
                <option disabled value="">Please select Allow or Not Allow</option>
                <option value="true">Allow Login</option>
                <option value="false">Not Allow Login</option>
              </select>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-if="so.sk != 'permissions' && so.sk != 'is_alive'" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
                <option disabled value="15">Show count : Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>

              <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
                <option disabled value="15">Please select interval : Default 15</option>
                <option value=10>10</option>
                <option value=30>30</option>
                <option value=60>60</option>
                <option value=300>300(5 min)</option>
              </select>
              <span v-if="sync.enable" class="float-right" style="margin-right:15px">
                <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
                <b-btn @click="pause" size="sm" variant="warning">
                  {{!sync.stop ? "Auto refresh"  : "Pause"}}
                </b-btn>
              </span>
              <div>
                <b-button size="sm" v-if="enable_new !== false" variant="success" @click="add"> New Registration </b-button>
              </div>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="status" slot-scope="row">
          <template v-if="row.item.is_del">
            <i class="fa fa-close" title="deleted user"></i>
          </template>
          <i v-if="row.item.is_alive" class="fa fa-unlock-alt" title="active user"></i>
          <i v-else class="fa fa-lock" title="inactive user"></i>
          <i v-if="row.item.is_verified" class="fa fa-envelope-open-o" title="email verified"></i>
        </template>
        <template slot="username" slot-scope="row">
          <del v-if="row.item.is_del">{{row.item.username}}</del>
          <template v-else>{{row.item.username}}</template>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level | level}}</template>
        <template slot="group.name" slot-scope="row">{{row.item.group && row.item.group.name}}</template>
        <template slot="last_visit" slot-scope="row">{{row.item.last_visit | sdate }}</template>
        <template slot="last_addr" slot-scope="row">{{row.item.last_addr }}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
        <!-- <b-col class="md-4">
          <div class="pull-right">
            <b-button size="sm" variant="success" @click="$router.push({ name: 'user', params: { id : 'add' } })"> New Registration </b-button>
          </div>
        </b-col> -->
      </b-row>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import { Api } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: 'username', sv: '', skt: 'username', opt : {}, adv: false
});
// props explain
// auto_refresh : auth sync enable or disable, value is boolean
// group : this component to group list, using by group dependency

export default {
  name : "userList",
  props: ['group', "auto_refresh", "view_detail", "enable_new", "delay"],
  watch: {
    group() {
      console.log("watch updated props data", this.group.groupname)
      this.load()
    }
  },
  components: { DatePicker, vSelect },
  data: () => ({
    codes,
    custom,
    so : default_opt(),
    sync : { th : undefined, stop : false, interval : 15, enable : false },
    summaryData : { enable : 0, disable : 0 },
    model : {}
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'id', thStyle: 'width: 10%', label: 'No.' },
        { key: 'group.groupname', sortable: true, label: 'Group' },
        { key: 'permissions', sortable: true, label: 'Permission', thStyle: 'width: 10%' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'username', sortable: true, label: 'Username'},
        { key: 'nickname', sortable: true, label: 'Nickname' },
        { key: 'last_visit', label: 'Last_visit', sortable: true, thStyle : 'width: 10%' },
        { key: 'last_addr', label: 'Last_addr', sortable: false, thStyle : 'width: 10%' },
        { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  }
      ]
      if(this.group) { f.splice(1, 1) }
      return f;
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['last_visit_ed'] = moment()
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_alive'] = 'true';
        this.so.opt['is_verified'] = 'true';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    summary() {
      Api.Partner({ target : 'user', cmd : 'summary', body : this.group ? { group_id : this.group.id } : '' })
        .then(rs => { this.summaryData = Object.assign(this.summaryData, rs.body) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    add() {
      if(this.view_detail !== false) {
        this.$router.push({ name: 'user', params: { id : 'add' } })
      } else {
        this.$router.push({ name: 'user', params: { id : this.$route.params.id, tag : "group" } })
      }
    },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        target : 'user', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : [{ name : 'is_del', value : false, op : '='}]
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '='}) }
      if(this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_alive':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'is_verified':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Partner(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail(item) { this.$router.push({ name : "user", params : { id : item.id } }); },
  },
  created() { console.log('User_List.vue', 'created'); },
  destroyed() { console.log('User_List.vue', 'destroyed'); },
  mounted() { console.log('User_List.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(!this.view_detail !== false) {
      // not component
      this.summary()
    }
  },
}
</script>
